import { render, staticRenderFns } from "./DogFlag.vue?vue&type=template&id=0b715a94&scoped=true"
import script from "./DogFlag.vue?vue&type=script&lang=js"
export * from "./DogFlag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b715a94",
  null
  
)

export default component.exports